import { Address } from '../../api/app-types/address.app';

export function buildAddress(address: Address | undefined) {
	if (!address) return;
	return `${address.streetAndHouseNumber} ${address.postalCodeAndCity}`.trim();
}
